/* 布局 */
//前台
import Layout from "@views/layout";

const cooperatebusinesscolumnRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "cooperatebusinesscolumn/list",
        name: "COOPERATEBUSINESSCOLUMN",
        meta: {
            title: "企业栏目",
            keepAlive:true
        },
        component: () => import("@views/business/cooperatebusinesscolumn/index.vue"),
    },
        ],
};

export default cooperatebusinesscolumnRouter;
